import ApiLpc from '@services/http/ApiLpc';
import { axiosClient, getUrl } from '@services/http/Http';
import { getCategoryIndex, isSupportedCategory } from '@services/utils/UserService';

const uploadImage = (base64Image: string | ArrayBuffer, service: string, ctx?: object) =>
    axiosClient(ctx)
        .post(getUrl(ApiLpc.FILE.UPLOAD_FILE, service), JSON.stringify(base64Image))
        .then((res) => res.data);

const customImageLoader = ({ src, width, quality }) => {
    return `${process.env.FRONTEND_BASE_URL}${src}?w=${width}&q=${quality || 75}`;
};

const getPotImage = (pot) => {
    if (pot.image) {
        return pot.image;
    }

    if (pot.category === 'SOLIDARITY_POOL') {
        return null;
    }

    if (pot.subdomainCreation != null) {
        switch (pot.subdomainCreation) {
            case 'DECATHLON':
                return `${process.env.LPC_IMAGES_SERVER}/static/img/default-images/decathlonDefault.jpg?h=5`;
            case 'RELAISCHATEAUX':
                return `${process.env.LPC_IMAGES_SERVER}/static/img/default-images/relaischateauxDefault.jpg?h=5`;
            case 'CREDITCOOPERATIF':
                return `${
                    process.env.LPC_IMAGES_SERVER
                }/static/img/default-images/defaultcreditcooperatif${getCategoryIndex(pot.category)}.jpg?h=5`;
            case 'BNC':
                return `${process.env.LPC_IMAGES_SERVER}/static/img/default-images/defaultbnc${getCategoryIndex(
                    pot.category,
                )}.png?h=5`;
            default:
                return `${process.env.LPC_IMAGES_SERVER}/static/img/default-images/defaultPot${getCategoryIndex(
                    pot.category,
                )}.jpg?h=5`;
        }
    }

    return isSupportedCategory(pot.category)
        ? `/front-static/images/pot/categories/${pot.category}.png`
        : `${process.env.LPC_IMAGES_SERVER}/static/img/default-images/defaultPot${getCategoryIndex(
              pot.category,
          )}.jpg?h=5`;
};

const imageService = {
    uploadImage,
    customImageLoader,
    getPotImage,
};

export default imageService;
